import React from 'react';
import { ConnectedPaxField } from '../FlightsManager/MobileFields/PaxField';

export const PaxSelectorMobile = ({ isHotelOptionEnabled }) => {
    return (
        <ConnectedPaxField isHotelOptionEnabled={isHotelOptionEnabled} />
    );
};
